var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DsButton',{staticClass:"form__add-btn",attrs:{"loading":_vm.isAdding,"icon":_vm.icon,"label":_vm.label,"theme":"light","variant":"icon"},on:{"click":_vm.add}})}
var staticRenderFns = []

export { render, staticRenderFns }